import React, { Component } from 'react';
import Loading from "../Loading/Loading";
import { Container } from 'reactstrap';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

import './Layout.css';

export class Layout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            message: navigator.language.startsWith('es') ? 'Cargando...' : 'Loading...'
        };
    }

    handleSidebarLoad = () => {
        this.setState({
            loading: false
        });
    };

    static displayName = Layout.name;

    render() {
        const { loading, message } = this.state;

        return (
            <div>
                <Header />
                <Sidebar onLoad={this.handleSidebarLoad}/>
                <div class="content-wrapper">
                    <div class="container-fluid margen-inferior">
                        {this.props.children}
                    </div>
                </div>
                <Footer />

                <Loading show={loading} message={message} />
            </div>
        );
    }
}